<template>
  <div>
    <div>
      <b>支持派件方式</b>
    </div>
    <div v-if="transport==='sea'">
      ［自己前往新北倉取件］<br>
      貨物抵達倉庫時，由客服通知，並自己前往新北倉取件。<br>
      <br>
      ［貨運公司宅配到府］<br>
      貨物抵達倉庫時，由新北倉協助安排貨運公司配送到指定地址1樓，運費優惠每筆訂單不限包裹件數、不限體積重量，<span class="red--text">僅需800元</span>台幣(不包含偏遠地區)。<br>
      偏遠地區收費表：
      <table class="table-comment text-center">
        <tr>
          <td colspan="3">
            偏遠地區
          </td>
        </tr>
        <tr>
          <td width="50">
            台中
          </td>
          <td>
            和平區 東勢區 新社區
          </td>
          <td width="60">
            1200
          </td>
        </tr>
        <tr>
          <td>南投</td>
          <td>
            埔里鎮 集集鎮 鹿谷鄉 水里鄉 魚池鄉 竹山鎮 國姓鄉 信義鄉 仁愛鄉 中寮鄉 名間鄉
          </td>
          <td>1500</td>
        </tr>
        <tr>
          <td>彰化</td>
          <td>二水鄉 田中鎮 社頭鄉 線西鄉</td>
          <td>1500</td>
        </tr>
        <tr>
          <td>嘉義</td>
          <td>
            阿里山 番路鄉 大埔鄉 中埔鄉 梅山鄉 竹崎鄉
          </td>
          <td>1500</td>
        </tr>
        <tr>
          <td>台南</td>
          <td>
            南化區 楠西區 左鎮區 龍崎區 東山區 白河區
          </td>
          <td>1500</td>
        </tr>
        <tr>
          <td>高雄</td>
          <td>
            旗山區 桃源區 那瑪夏區 六龜區 茂林區 甲仙區 衫林區 内門區 美濃區
          </td>
          <td>2000</td>
        </tr>
        <tr>
          <td>屏東</td>
          <td>除 屏東市/萬丹鄉/九如鄉/新園鄉/里港鄉 以外地區</td>
          <td>2000</td>
        </tr>
        <tr>
          <td colspan="2">
            屏東恆春/滿州
          </td>
          <td>5500</td>
        </tr>
        <tr>
          <td>花蓮</td>
          <td>全區</td>
          <td>3000</td>
        </tr>
        <tr>
          <td>台東</td>
          <td>全區</td>
          <td>3500</td>
        </tr>
      </table>
      <br>
      <div>
        *山區目前無法提供宅配服務，僅能自取或自行聯絡回頭車取件。<br>
        *不支持離島派件。
      </div>
    </div>
    <div v-else>
      <div>
        超商<br>
        1. 長+寬+高≦105公分<br>
        2. 單邊長≦45公分、其他兩邊≦30公分<br>
        3. 重量10公斤以內<br>
      </div>
      <div class="mt-2">
        黑貓<br>
        尺寸在120公分以下（長+寬+高三邊合計），20公斤以內。
      </div>
      <div class="mt-2">
        新竹<br>
        無限制
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    transport: String
  },
}
</script>
